import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../../../../../_services/alert.service";
import {MenusService} from "../../../../../_services/menu.service";
import {Location} from "@angular/common";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors, ValidatorFn,
  Validators
} from "@angular/forms";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MerchantService} from "../merchant.service";
import {ActivatedRoute, Params} from "@angular/router";
import {lastValueFrom, Observable, Subscriber, Subscription} from "rxjs";
import {DataTable} from "simple-datatables";
import {StorageService} from "../../../../../_services/storage.service";
import {ModalComponent} from "../../../../../common/modal/modal.component";
import {ModalConfig} from "../../../../../common/modal/modal.config";
import Swal, {SweetAlertResult} from "sweetalert2";
import {LoaderService} from "../../../../../_services/loader.service";
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { NgbDateStruct, NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { log } from 'console';
import { UserService } from 'src/app/_services/user.service';
import { CountryMasterService } from '../../../fraud-prevention/country-master-rule/country-master-service';
import { HttpClient } from '@angular/common/http';
import { ProductService } from '../../../product-management/product-service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE,defaultCountryCode,defaultCountryName} = environment;


const allowedExtensions = ["pdf", "PDF", "png", "PNG", "jpg", "JPG", "jpeg", "JPEG", "BMP", "bmp"];

@Component({
  selector: 'app-merchant-kyc-upload',
  templateUrl: './merchant-kyc-upload.component.html',
  styleUrls: ['./merchant-kyc-upload.component.scss']
})
export class MerchantKycUploadComponent implements OnInit, OnDestroy {
  @ViewChild('waverError') waverError: ElementRef
  kycUploadModalConfig: ModalConfig;
  kycViewModalConfig: ModalConfig;
  merchantId: any;
  type : any;
  merchantDetails: any;
  merchantKycDetails: any;
  allKycDataFormGroup: FormGroup;
  kycApprovalForm: FormGroup;
  permissions: any;
  isKycFormSubmitted: boolean
  currentDate = new Date();
  status: any;
  isApprovalEnable: boolean = false;
  dataTable: DataTable;
  remarkData: any;
  currentSelectedGroup: any;
  globalDisableFlag: boolean = false;
  localDisableFlag: boolean = false;
  kycFileSrc: any;
  loader: any = false;
  pageSize: number = 10;
  merchantListData: any = [];
  callCenterView :boolean = false;

  currentDateUBO :any = new Date();
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  currentDateUBOPassport :any = new Date();
  minDatePassport: NgbDateStruct;
  maxDatePassport : NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  maxDateFromPassport: NgbDateStruct;
  maxDateFromDob : NgbDateStruct;
  maxDateFromHundred : NgbDateStruct;
  model: NgbDateStruct | null = null;
  public eidRegex : any = /^784\d{4}\d{7}\d{1}$/;

  UBOList : any [];
  showFinalButton : boolean = false;
  countryListDropdown : any=[];
  totalPercentage : any = 0;
  typeOfShareholderDropdown : any=['Individual','Entity',];
  roleInEntityDropdown : any=['Business Owner','Shareholder / Director',];
  companyTypeDropdown : any=[
    'Sole Proprietorship',
    'Limited Liability Company (LLC)',
    'Limited Partnership',
    'General Partnership',
    'Corporation',
    'Civil Company',
    'Free Zone Establishment (FZE): Single shareholder company',
    'Free Zone Company (FZC): Company with two or more shareholders',
    'Public Joint Stock Company (PJSC)',
    'Private Joint Stock Company (PrJSC)',
    'Foundation',
    'Charity',
    'Government Entity',
    'Trust',
    'Others'
  ];
  idTypeDropdown : any = ['Trade License','Business License','Certificate of Incorporation','Commercial Registration']

  fileName: string = '';
  fileUrl: string = '';
  enableAddButton : boolean = true;
  hasPOA : boolean = false;

  formGroup: FormGroup;
  private downloadUrl : string = `${API_URLBLAZE}/product/icon/get-profile?url=`;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true
  };
  @ViewChild('kycUploadModal') private kycUploadModal: ModalComponent;
  @ViewChild('kycFileViewModal') private kycFileViewModal: ModalComponent;
  private queryParams: Params;
  private documentId: any;
  private subscriber$: Subscription;

  public columnDefs: ColDef[] = [
    {field: 'id', tooltipField: 'id', headerName: 'ID', hide: true},
     {field: 'appStatus', tooltipField: 'productId', headerName: 'Status'},
    {field: 'appRemark', tooltipField: 'bankName', headerName: 'Remark'},
    {field: 'addedBy', tooltipField: 'isVerified', headerName: 'Added By'},
    {field: 'addedOn', tooltipField: 'bankName', headerName: 'Added On'},
  ];

  public tableSelectedColumn: ColDef[] = [...this.columnDefs];

  constructor(
    private alertService: AlertService,
    private menuService: MenusService,
    private location: Location,
    private route: ActivatedRoute,
    public formBuilder: FormBuilder,
    private merchantService: MerchantService,
    private storage: StorageService,
    private sanitizer: DomSanitizer,
    private loaderService: LoaderService,
    private userService : UserService,
    private ngbCalender: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private countryService : CountryMasterService,
    private http: HttpClient,
    private productService : ProductService


  ) {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    this.route.queryParams
      .subscribe(params => {
          this.queryParams = params;
          this.merchantId = params?.mid;
          this.type = params?.type;
          console.log(this.type)
          // this.merchantId = "2413801395806061";
          try {
            // this.merchantService.getOnboardingRemark(this.merchantId)
            //   .subscribe((data: any) => {
            //     if(data.response.data.length > 0 ){
            //       this.remarkData = data.response.data
            //       this.dataTable ? this.dataTable.destroy() : console.log(this.remarkData)
            //       this.remarkData ? this.dataTable = new DataTable("#dataTableExample") : this.dataTable.destroy()
            //     }
            //       if (this.remarkData) {
            //         this.remarkData.forEach((element: any) => {
            //           this.dataTable.rows().add(Object.values(element));
            //         })
            //       }
            //     }
            //   )
            // this.merchantService.getMerchant(this.merchantId).subscribe((mData) => {

            //   this.merchantListData.push({
            //     // merchant_name: mData[0]?.merchant_name,
            //     MerchantId: this.merchantId
            //   })
            // })
          } catch (e) {
            this.remarkData = []
          }
        }
      );
    this.kycApprovalForm = new FormGroup({
      remarks: new FormControl('', [Validators.required]),
    })

    this.formGroup = this.formBuilder.group({
      formArray: this.formBuilder.array([]) // Initialize FormArray inside FormGroup
    });
    // this.addForm(); // Add first form by default

    this.minDate = this.ngbCalender.getToday();
    this.minDatePassport = this.ngbCalender.getToday();
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDateFromDob = new NgbDate(this.maxDateFrom.year, this.maxDateFrom.month, this.maxDateFrom.day - 1);
    this.maxDate = this.ngbCalender.getToday();

    this.maxDateFromPassport = this.ngbCalender.getToday();
    this.maxDatePassport = this.ngbCalender.getToday();

    this.fetchUBODetails();
    this.fetchCountryList();
    this.setMaxDate();
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.merchantService.getOnboardingRemark(this.merchantId,"KYC")
              .subscribe((data: any) => {
                console.log(data);
                this.remarkData = data.response.data;
              })
  }

  updateHasPOA() {
  this.hasPOA = !!this.UBOList?.some(
    (ubo: any) => ubo?.typeOfShareHolder === 'POA'
  );
  }

  get kycForm(): any {

    return this.allKycDataFormGroup.controls;
  }

  get isWavier() {
    return this.allKycDataFormGroup.get('isWavier');
  }

  get wavierRemarks() {
    return this.allKycDataFormGroup.get('wavierRemarks');
  }

  get wavierOffDate() {
    return this.allKycDataFormGroup.get('wavierOffDate');
  }

  get merchantKycData(): FormArray {

    return this.allKycDataFormGroup.get('merchantKycData') as FormArray;
  }

  merchantKycDataArr(): any {

    return (this.allKycDataFormGroup.get('merchantKycData') as FormArray)?.controls;
  }

  docTypArr(docType: FormControl): any {

    return (docType.get('docTypeList') as FormArray)?.controls;
  }

  async ngOnInit(): Promise<void> {

    const self = this;
    const merchantDetails$ = this.merchantService.getMerchant(this.merchantId)
    this.merchantDetails = await lastValueFrom(merchantDetails$);
    // this.status = this.merchantDetails[0]?.kyc_approvel
    this.status = "Pending";
    this.userService.getUserProfileNew().subscribe((data) => {
      if(data.ROLEID == 273){
        this.callCenterView = true;
      }
    });

    this.kycUploadModalConfig = {
      modalTitle: "Merchant Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.kycViewModalConfig = {
      modalTitle: "Merchant Status",
      modalSize: 'xl',
      fullscreen: true,
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      },
      onClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onTopClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onDismiss(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      }
    }

    await this.setKycData();
debugger
    this.subscriber$ = this.merchantService.kycUploadObserver.subscribe(async (data: any) => {

      try {
        if (data?.type == 'FILE_UPLOAD') {
          const {outIndex, innerIndex, type, fileUploadDetails} = data?.fileData;
          // console.log("File Upload===========>>>>>>", outIndex, innerIndex, type, fileUploadDetails, !isNaN(innerIndex))
          if (!isNaN(innerIndex)) {
            const controls = ((this.merchantKycDataArr()[outIndex]?.get('docTypeList') as FormArray)?.controls[innerIndex]?.get('docList') as FormArray)?.controls;
            if (controls && controls[0]?.get('docPath')?.value == '' && controls[0]?.get('kycId')?.value != 0) {
              controls[0].patchValue({
                docName: fileUploadDetails?.docName || fileUploadDetails?.docname || '',
                docPath: fileUploadDetails?.docPath || fileUploadDetails?.docpath || '',
              })
            } else if (controls?.filter((u: any) => u.get('docPath')?.value == '').length > 0) {
              const cnt = controls?.find((u: any) => u.get('docPath')?.value == '')
              cnt?.patchValue({
                docName: fileUploadDetails?.docName || fileUploadDetails?.docname || '',
                docPath: fileUploadDetails?.docPath || fileUploadDetails?.docpath || '',
              })
            } else {
              controls.push(this.addDocList(fileUploadDetails));
            }
            ((this.merchantKycDataArr()[outIndex]?.get('docTypeList') as FormArray)?.controls[innerIndex]?.get('docList') as FormArray).updateValueAndValidity();
          } else {
            const controls = this.merchantKycDataArr()[outIndex]?.get('docList').controls;

            if (controls[0]?.get('docPath').value == '') {
              controls[0].patchValue({
                docName: fileUploadDetails?.docName || fileUploadDetails?.docname || '',
                docPath: fileUploadDetails?.docPath || fileUploadDetails?.docpath || '',
              })
            } else if (controls?.filter((u: any) => u.get('docPath')?.value == '').length > 0) {
              const cnt = controls?.find((u: any) => u.get('docPath')?.value == '')
              cnt?.patchValue({
                docName: fileUploadDetails?.docName || fileUploadDetails?.docname || '',
                docPath: fileUploadDetails?.docPath || fileUploadDetails?.docpath || '',
              })
            } else {
              controls.push(this.addDocList(fileUploadDetails));
            }
            this.merchantKycDataArr()[outIndex]?.get('docList').updateValueAndValidity();
          }

        }
        debugger

        if (data?.type == 'FILE_DELETE') {
          const {outIndex, innerIndex, type, fileIndex} = data?.fileData;
          if (!isNaN(innerIndex)) {
            const docListFArr = ((this.merchantKycDataArr()[outIndex]?.get('docTypeList') as FormArray)?.controls[innerIndex]?.get('docList') as FormArray);
            const controls = docListFArr?.controls;
            // console.log("Delete---<", controls);
            this.deleteFileService(
              controls[fileIndex]?.get('docPath')?.value,
              controls[fileIndex]?.get('kycId')?.value,
              controls[fileIndex]?.get('docName')?.value
            ).then((dataDel: any) => {
              if (!dataDel?.isDismissed) {
                docListFArr.removeAt(fileIndex, {emitEvent: true})
              }
              this.currentSelectedGroup = {
                outIndex,
                innerIndex,
                type,
                currentFormGroup: this.merchantKycDataArr()[outIndex]
              };

            })
          } else {
            const docListFArr = (this.merchantKycDataArr()[outIndex]?.get('docList') as FormArray);
            const controls = docListFArr?.controls;
            this.deleteFileService(
              controls[fileIndex]?.get('docPath')?.value,
              controls[fileIndex]?.get('kycId')?.value,
              controls[fileIndex]?.get('docName')?.value
            ).then((dataDel: any) => {
              if (!dataDel?.isDismissed) {
                docListFArr.removeAt(fileIndex, {emitEvent: true})
              }
              this.currentSelectedGroup = {
                outIndex,
                innerIndex,
                type,
                currentFormGroup: this.merchantKycDataArr()[outIndex]
              };
              // this.merchantService.uploadKycBrowseButton(this.currentSelectedGroup);
            })

          }
        }
        if (data?.type == 'FILE_DOWNLOAD') {
          const {outIndex, innerIndex, type, fileIndex} = data?.fileData;
          if (!isNaN(innerIndex)) {
            const controls = ((this.merchantKycDataArr()[outIndex]?.get('docTypeList') as FormArray)?.controls[innerIndex]?.get('docList') as FormArray)?.controls;
            // console.log("In---<", controls);
            this.downloadFileService(controls[fileIndex]?.get('docName')?.value, controls[fileIndex]?.get('docPath')?.value)
          } else {
            const controls = this.merchantKycDataArr()[outIndex]?.get('docList').controls;
            this.downloadFileService(controls[fileIndex]?.get('docName')?.value, controls[fileIndex]?.get('docPath')?.value)
            // console.log("Out---<", controls);
          }
        }

        if (data?.type == 'FILE_VIEWED') {
          this.loader = true;
          this.loaderService.showLoader();
          const {outIndex, innerIndex, type, fileIndex} = data?.fileData;
          if (!isNaN(innerIndex)) {
            const controls = ((this.merchantKycDataArr()[outIndex]?.get('docTypeList') as FormArray)?.controls[innerIndex]?.get('docList') as FormArray)?.controls;
            this.kycViewModalConfig = {
              ...this.kycViewModalConfig,
              modalTitle: `${controls[fileIndex]?.get('docName')?.value}`
            }
            const viewResp: any = await this.viewFileService(controls[fileIndex]?.get('docName')?.value, controls[fileIndex]?.get('docPath')?.value)
              .catch((err) => {
                this.alertService.toastErrorMessageAlert({html: `Error occurred while showing file ${controls[fileIndex]?.get('docName')?.value}`})
                return null;
              });
            console.log("======>", viewResp);
            this.loaderService.hideLoader();
            if (!this.kycFileViewModal.isModalOpen && viewResp?.src) {
              await this.kycFileViewModal.open()
            }
            // this.loaderService.hideLoader();
            // console.log("In---<", controls);
            // this.downloadFileService(controls[fileIndex]?.get('docName')?.value, controls[fileIndex]?.get('docPath')?.value)
          } else {
            const controls = this.merchantKycDataArr()[outIndex]?.get('docList').controls;
            this.kycViewModalConfig = {
              ...this.kycViewModalConfig,
              modalTitle: `${controls[fileIndex]?.get('docName')?.value}`
            }
            const viewResp: any = await this.viewFileService(controls[fileIndex]?.get('docName')?.value, controls[fileIndex]?.get('docPath')?.value)
              .catch((err) => {
                this.alertService.toastErrorMessageAlert({html: `Error occurred while showing file ${controls[fileIndex]?.get('docName')?.value}`})
                return null;
              });
            console.log("======>", viewResp);
            this.loaderService.hideLoader();
            if (!this.kycFileViewModal.isModalOpen && viewResp?.src) {
              await this.kycFileViewModal.open()
            }
          }
          this.loaderService.hideLoader();
        }
      } catch (e) {
        this.loaderService.hideLoader();
        console.error(e);
      }

    })

     console.log('Kyc Form Group--->', this.allKycDataFormGroup)
    if (!this.isApprovalEnable) {
      this.kycApprovalForm.disable();
    }

  }

  ngOnDestroy() {
    console.log("Destroy called===>")
    this.subscriber$.unsubscribe()
  }

  async setKycData() {
    let businessType = Number(this.merchantDetails?.response?.data?.businesstype) || 1;
    // if(this.type != null){
    //   if(this.type == "SELF"){
    //     businessType = 11;
    //   }
    // }
    const merchantKycDetails$ = this.merchantService.getMerchantKycDetails(businessType,this.merchantId)
    this.merchantKycDetails = await lastValueFrom(merchantKycDetails$);
console.log('RR Kyc Data : ');
console.log(this.merchantKycDetails);

    const kycDetails = this.reformatKycData(this.merchantKycDetails);

    console.log("kycDetails:::"+kycDetails);
    const {allow_wavier, wavier_date, wavier_remark, businessTypeId,mandatory} = kycDetails[0] || {}
    this.documentId = businessTypeId
    console.log("businessTypeId:::"+businessTypeId)
    console.log("documentId:::"+this.documentId)

    console.log('Waive Kyc===>', kycDetails)

    this.allKycDataFormGroup = new FormGroup({
      merchantId: new FormControl(this.merchantId),
      isWavier: new FormControl(!!(allow_wavier == 'Y' || (wavier_remark && wavier_remark != ''))),
      wavierRemarks: new FormControl(wavier_remark || ''),
      wavierOffDate: new FormControl(wavier_date || ''),
      merchantKycData: new FormArray(this.loadKycData(kycDetails)),
      mandatory:new FormControl(mandatory || ''),
    });

    console.log("++++++++======>", this.allKycDataFormGroup.value);
    this.allKycDataFormGroup.updateValueAndValidity();

    this.onChangeWavier();

    console.log(this.permissions)
    if (!(this.permissions.includes('Add'))) {
      this.globalDisableFlag = true;
      // console.log('------------======+)))))========------>')
      this.allKycDataFormGroup.disable();
      this.formGroup.disable();
      this.allKycDataFormGroup.get('wavierRemarks')?.disable()
      // document.getElementById('wavierRemarks')?.setAttribute('disabled', 'disabled')
      this.allKycDataFormGroup.get('wavierOffDate')?.disable()
      // document.getElementById('wavierOffDate')?.setAttribute('disabled', 'disabled')
    }
  }

  getDocList(index: number) {
    return this.merchantKycData.controls[index].get('docList') as FormArray
  }

  getDocCount(u: FormGroup) {
    return (u?.get('docList') as FormArray)?.controls?.filter((cnt) => cnt?.get('docPath')?.value !== '')?.length || 0
  }

  getDocListItem(index: number, listIndex: number) {
    return this.getDocList(index).controls[listIndex] as FormGroup
  }

  getDocListError(index: number) {
    let error: any | null = null;
    const type = this.merchantKycData.controls[index].get('type')?.value
    if (type == 'other' || type == 'multi') {
      let allFalse = true;
      // console.log(index,'---', this.merchantKycData.controls[index]);
      (this.merchantKycData.controls[index].get('docTypeList') as FormArray)?.controls.forEach((listItem, innIndex) => {
        // console.log(index,'---', listItem.get('isSelected')?.value);
        if (listItem.get('isSelected')?.value) {
          allFalse = false;
        }
      })
      if (allFalse && !this.isWavier?.value) {
        if (!error) error = {};
        error['required'] = true;
      }
    }

    if (type == 'multi' || type == 'other') {
      (this.merchantKycData.controls[index].get('docTypeList') as FormArray)?.controls.forEach((listItem, innIndex) => {
        // console.log("In Error===>", this.getDocTypeListError(index, innIndex)?.errors);
        const listItemPathError = this.getDocTypeListError(index, innIndex)?.errors;
        if (listItemPathError) {
          if (!error) error = {};
          Object.keys(listItemPathError || {}).forEach((key) => {
            error[key] = listItemPathError[key];
          })
        }
      });
    }
    this.getDocList(index).controls.forEach((listItem, listIndex) => {
      const listItemPathError = this.getDocListItem(index, listIndex).get('docPath')?.errors
      const listItemNameError = this.getDocListItem(index, listIndex).get('docName')?.errors
      // const listItemErrorNew= this.getDocListItem(index, listIndex)


      if (listItemPathError) {
        if (!error) error = {};
        Object.keys(listItemPathError || {}).forEach((key) => {
          error[key] = listItemPathError[key];
        })
      }
      if (listItemNameError) {
        if (!error) error = {};
        Object.keys(listItemNameError || {}).forEach((key) => {
          error[key] = listItemNameError[key];
        })
      }
    });
    return error ? {errors: error} : error;
  }

  getDocTypeList(index: number, rad: number) {
    return (this.merchantKycData?.controls[index]?.get('docTypeList') as FormArray)?.controls[rad]?.get('docList') as FormArray
  }

  getDocTypeListItem(index: number, rad: number, listIndex: number) {
    return this.getDocTypeList(index, rad).controls[listIndex] as FormGroup
  }

  getDocTypeListError(index: number, rad: number) {
    let error: any | null = null;
    this.getDocTypeList(index, rad).controls.forEach((listItem, listIndex) => {
      const listItemPathError = this.getDocTypeListItem(index, rad, listIndex).get('docPath')?.errors
      const listItemNameError = this.getDocTypeListItem(index, rad, listIndex).get('docName')?.errors
      // const listItemErrorNew= this.getDocListItem(index, listIndex)

      if (listItemPathError) {
        if (!error) error = {};
        Object.keys(listItemPathError || {}).forEach((key) => {
          error[key] = {docPath: listItemPathError[key]};
        })
      }
      if (listItemNameError) {
        if (!error) error = {};
        Object.keys(listItemNameError || {}).forEach((key) => {
          error[key] = {docName: listItemNameError[key]};
        })
      }
    });
    const listItemError = this.getDocTypeList(index, rad)?.errors
    if (listItemError) {
      if (!error) error = {};
      Object.keys(listItemError || {}).forEach((key) => {
        error[key] = listItemError[key];
      })
    }
    return error ? {errors: error} : error;
  }

  onDocTypeChangeSingle(index: number, rad?: number) {

    let status = true;
    const controls = this.merchantKycDataArr()[index].get('docTypeList').controls;
    console.log("Controls ", controls);

    if (!isNaN(<number>rad)) {

      // @ts-ignore
      const control = this.merchantKycDataArr()[index].get('docTypeList').controls[rad];
      // console.log("---In Rad---->", control)
      const val = control.get('isSelected').value;
      if (val) {

        status = false
      }

      console.log("//////////======>", this.getDocTypeList(index, <number>rad));
      if (!status) {

        control.get('docType')?.setValidators([Validators.required])
        control?.updateValueAndValidity();
        this.getDocTypeList(index, <number>rad)?.setValidators([Validators.required, Validators.minLength(1)])
        this.getDocTypeList(index, <number>rad)?.updateValueAndValidity()
        this.getDocTypeList(index, <number>rad).controls.forEach((docListItem, listIndex) => {
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docPath')?.setValidators([Validators.required])
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docName')?.setValidators([Validators.required])
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docPath')?.updateValueAndValidity()
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docName')?.updateValueAndValidity()
          // console.log(`${listIndex}===>>>>>`, this.getDocTypeListError(index, <number>rad)?.errors)
        });
      } else {

        this.getDocTypeList(index, <number>rad)?.setValidators([])
        this.getDocTypeList(index, <number>rad)?.updateValueAndValidity()
        this.getDocTypeList(index, <number>rad).controls.forEach((docListItem, listIndex) => {
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docPath')?.setValidators([])
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docName')?.setValidators([])
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docPath')?.updateValueAndValidity()
          this.getDocTypeListItem(index, <number>rad, listIndex).get('docName')?.updateValueAndValidity()

          // console.log(`${listIndex}=++++==>>>>>`, this.getDocTypeListError(index, <number>rad)?.errors)
        });
      }
      return status;
    }
    if (controls.length == 0) return false;
    controls.forEach((control: any, ind: number) => {
      // console.log("Onchange Raido------>", control?.value);
      const val = control.get('isSelected').value;
      if (val) {
        status = false
      }
    })
    if (!status) {
      this.getDocList(index).controls.forEach((docListItem, listIndex) => {
        this.getDocListItem(index, listIndex).get('docPath')?.setValidators([Validators.required])
        this.getDocListItem(index, listIndex).get('docName')?.setValidators([Validators.required])
        this.getDocListItem(index, listIndex).get('docPath')?.updateValueAndValidity()
        this.getDocListItem(index, listIndex).get('docName')?.updateValueAndValidity()

        // console.log(`${listIndex}===>>>>>`, this.getDocListError(index)?.errors)
      });
    } else {
      this.getDocList(index).controls.forEach((docListItem, listIndex) => {
        this.getDocListItem(index, listIndex).get('docPath')?.setValidators([])
        this.getDocListItem(index, listIndex).get('docName')?.setValidators([])
        this.getDocListItem(index, listIndex).get('docPath')?.updateValueAndValidity()
        this.getDocListItem(index, listIndex).get('docName')?.updateValueAndValidity()

        // console.log(`${listIndex}=+++++==>>>>>`, this.getDocListError(index)?.errors)
      });
    }
    return status;
  }

  public wavierValidator(): ValidatorFn {
    return (controls: AbstractControl) => {
      const isWavier = controls.get('isWavier');
      const wavierOffDate = controls.get('wavierOffDate');
      const wavierRemarks = controls.get('wavierRemarks');
      const merchantKycData = controls.get('merchantKycData') as FormArray;

      // console.log("In validator===>", isWavier?.value)
      // console.log(merchantKycData?.controls);
      let waiverError = true;

      if (isWavier?.value) {
        waiverError = !waiverError;
        wavierOffDate?.addValidators([Validators.required])
        wavierRemarks?.addValidators([Validators.required])
      } else {
        wavierOffDate?.addValidators([])
        wavierRemarks?.addValidators([])
      }
      // wavierOffDate?.updateValueAndValidity()
      // wavierRemarks?.updateValueAndValidity()
      merchantKycData?.controls.forEach((fbControl: any) => {
        if (fbControl.get('type')?.value == 'single') {
          if (fbControl.get('docTypeList').length == 0) {
            fbControl?.setValidators([this.noDocTypeValidator(controls as FormGroup, isWavier?.value)])
          } else {
            fbControl?.setValidators([this.singleDocTypeValidator(controls as FormGroup, isWavier?.value)])
          }
        }
        if (fbControl.get('type')?.value == 'other') {
          fbControl?.setValidators([this.otherDocTypeValidator(controls as FormGroup, isWavier?.value)])
        }
        if (fbControl.get('type')?.value == 'multi') {
          fbControl?.setValidators([this.multiDocTypeValidator(controls as FormGroup, isWavier?.value)])
        }
      })

      return waiverError ? {waiverError: true} : null;
    };
  }

  onChangeWavier($event?: Event) {
    // console.log("onWaiverChange---->", this.isWavier?.value)
    if (this.isWavier?.value) {
      this.wavierRemarks?.setValidators([Validators.required])
      this.wavierOffDate?.setValidators([Validators.required])
      this.wavierRemarks?.updateValueAndValidity()
      this.wavierOffDate?.updateValueAndValidity()
      this.merchantKycData.controls.forEach((listItem, index) => {
        // console.log("++===>", listItem?.get('type')?.value)
        this.getDocList(index).controls.forEach((docListItem, listIndex) => {
          this.getDocListItem(index, listIndex).get('docPath')?.setValidators([])
          this.getDocListItem(index, listIndex).get('docName')?.setValidators([])
          this.getDocListItem(index, listIndex).get('docPath')?.updateValueAndValidity()
          this.getDocListItem(index, listIndex).get('docName')?.updateValueAndValidity()

          // console.log(`${listIndex}===>>>>>`, this.getDocListItem(index, listIndex)?.errors)
        });
      })
    } else {
      this.wavierRemarks?.setValidators([])
      this.wavierOffDate?.setValidators([])
      this.wavierRemarks?.updateValueAndValidity()
      this.wavierOffDate?.updateValueAndValidity()
      this.merchantKycData.controls.forEach((listItem, index) => {
        // console.log("++===>", listItem?.get('type')?.value)
        this.getDocList(index).controls.forEach((docListItem, listIndex) => {
          this.getDocListItem(index, listIndex).get('docPath')?.setValidators([Validators.required])
          this.getDocListItem(index, listIndex).get('docName')?.setValidators([Validators.required])
          this.getDocListItem(index, listIndex).get('docPath')?.updateValueAndValidity()
          this.getDocListItem(index, listIndex).get('docName')?.updateValueAndValidity()

          // console.log(`${listIndex}===>>>>>`, this.getDocListItem(index, listIndex)?.errors)
        });
      })
    }
  }

  isKycValid(): boolean {
    debugger
    let status = true;
    if (this.wavierRemarks?.errors) status = false;
    if (this.wavierOffDate?.errors) status = false;
    this.merchantKycData.controls.forEach((kycItem, ind) => {
    //  if (this.getDocListError(ind)?.errors) status = false;
    })

    return status
  }

  public noDocTypeValidator(kycForm: FormGroup, waiverValue: any): ValidatorFn {
    return (controls: AbstractControl) => {
      const docType = controls.get('docTypeList');
      const docList = controls.get('docList') as FormArray;
      const document = controls.get('document');
      const docName = controls.get('docName');
      const docPath = controls.get('docPath');
      const type = controls.get('type');

      // console.log("In noDocTypeValidator===>",kycForm, waiverValue)
      // console.log("In noDocTypeValidator Val===>",docType, docList, document, docName, docPath, type)

      if (waiverValue) {
        docList.controls.forEach((listItem) => {
          listItem.get('docName')?.addValidators([Validators.required]);
          listItem.get('docPath')?.addValidators([Validators.required]);
        })
      } else {
        docList.controls.forEach((listItem) => {
          listItem.get('docName')?.clearValidators()
          listItem.get('docPath')?.clearValidators();
        })
      }

      let waiverError = true;

      return waiverError ? {waiverError: true} : null;
    };
  }

  public singleDocTypeValidator(kycForm: FormGroup, waiverValue: any): ValidatorFn {
    return (controls: AbstractControl) => {
      const isWavier = controls.get('isWavier');
      const docType = controls.get('docTypeList');
      const docList = controls.get('docList');
      const document = controls.get('document');
      const docName = controls.get('docName');
      const docPath = controls.get('docPath');
      const type = controls.get('type');

      // console.log("In singleDocTypeValidator===>",kycForm, waiverValue)
      // console.log("In singleDocTypeValidator Val===>",docType, docList, document, docName, docPath, type)

      let waiverError = true;

      return waiverError ? {waiverError: true} : null;
    };
  }

  public multiDocTypeValidator(kycForm: FormGroup, waiverValue: any): ValidatorFn {
    return (controls: AbstractControl) => {
      const isWavier = controls.get('isWavier');
      const docType = controls.get('docTypeList');
      const docList = controls.get('docList');
      const document = controls.get('document');
      const docName = controls.get('docName');
      const docPath = controls.get('docPath');
      const type = controls.get('type');

      // console.log("In multiDocTypeValidator===>",kycForm, waiverValue)
      // console.log("In multiDocTypeValidator Val===>",docType, docList, document, docName, docPath, type)

      let waiverError = true;

      return waiverError ? {waiverError: true} : null;
    };
  }

  public otherDocTypeValidator(kycForm: FormGroup, waiverValue: any): ValidatorFn {
    return (controls: AbstractControl) => {
      const isWavier = controls.get('isWavier');
      const docType = controls.get('docTypeList');
      const docList = controls.get('docList');
      const document = controls.get('document');
      const docName = controls.get('docName');
      const docPath = controls.get('docPath');
      const type = controls.get('type');

      // console.log("In otherDocTypeValidator===>",kycForm, waiverValue)
      // console.log("In otherDocTypeValidator Val===>",docType, docList, document, docName, docPath, type)

      let waiverError = true;

      return waiverError ? {waiverError: true} : null;
    };
  }

  reformatKycData(kycData: any[]) {

    const formatted: any[] = [];
    kycData.forEach((kyc) => {

      if (kyc.docpath && kyc.docpath !== '') {
        this.isApprovalEnable = true
      }
      if (kyc.allow_wavier && kyc.allow_wavier !== ''&& kyc.allow_wavier!=="null") {

        this.isApprovalEnable = true
      }
      const fil = formatted.filter((d) => d.docid == kyc.docid)
      if (fil.length == 0) {
        if (kyc.type == 'single') {
          const singleDocTypeList = kycData.filter((d) => d.docid == kyc.docid && d.type == kyc.type);

          formatted.push({
            ...kyc,
            docList: singleDocTypeList || [],
            documentDescriptionType: []
          })
        } else if (kyc.type == 'multi' || kyc.type == 'other') {
          // console.log("KYC------>", kyc)
          let filOt = kycData.filter((d) => d.docid == kyc.docid && d.type == kyc.type && d.docType).sort((a, b) => a.docType == b.docType ? 1 : 0)

          const def = {
            allow_wavier: kyc.allow_wavier,
            businessType: kyc.businessType,
            businessTypeId: kyc.businessTypeId,
            docType: "",
            docid: kyc.docid,
            docname: "",
            docpath: "",
            document: kyc.document,
            subtext: kyc?.subtext,
            documentDescription: kyc.documentDescription,
            kycId: 0,
            type: kyc.type,
            wavier_date: kyc.wavier_date,
            wavier_remark: kyc.wavier_remark
          };
          // console.log("KYC Fil------>", [...filOt])
          const des: any[] = [];
          //based on doc description
          kyc.documentDescription.forEach((de: string) => {
            if (de !== '') {
              const dType = filOt.findIndex((d) => d.docType == de);
              const dTypeDocList = filOt.filter((d) => d.docType == de);
              console.log("========----->>>>", de, dTypeDocList)


              if (dType !== -1) {
                des.push({
                  ...filOt[dType],
                  docList: dTypeDocList || [],
                });
                // filOt.splice(dType, 1)
                filOt.forEach((d, index) => {
                  d.docType == de && filOt.splice(index, 1)
                });
                filOt = filOt.filter((d) => d.docType != de);
              } else {
                des.push({
                  ...def,
                  docList: [],
                  docType: de
                })
              }
              // console.log(de, "=---->", dType, [...filOt])
            }
          })
          console.log("========----->>>>", [...filOt])
          // des.push(...filOt);
          // filOt.forEach((dT)=>{
          let counter = 0;
          let removeItmes = [];
          while (filOt[counter]) {
            const dT = filOt[counter];
            const dType = filOt.findIndex((d) => d.docType == dT.docType);
            const dTypeDocList = filOt.filter((d) => d.docType == dT.docType);

            // console.log("KYC Fil Type------>", dT.docType, dTypeDocList)

            if (dType !== -1) {
              des.push({
                ...filOt[dType],
                docList: dTypeDocList || [],
              });
              // filOt.splice(dType, 1)
              const indexRm: number[] = [];
              filOt.forEach((d, index) => {
                // console.log("KYC Fil Before SPlice------>", [...filOt])
                if (d.docType == dT.docType) {
                  indexRm.push(index);
                }
              });
              indexRm.forEach((ind, index) => {
                removeItmes.push(...filOt.splice((ind - index), 1));
              })
              console.log("indexRm--->", indexRm);
            }
            if (filOt.length > 1 && removeItmes.length == 0) counter++;
            else counter = 0;
            console.log("Pointer--->", counter, [...filOt]);
          }
          // })

          // des.push({
          //   ...filOt[dType],
          //   docList : dTypeDocList || [],
          // });

          formatted.push({
            ...kyc,
            documentDescriptionType: des
          })
        }

      }
      // console.log("End====>>>>>>>>>>");
    })
    // console.log("formatted===>", formatted)
    return formatted;
  }

  loadKycData(kycData: any) {

    let data: any = [];
    (kycData ?? []).forEach((item: any) => {
      // console.log("========>", item);
      if (item.type == 'other') {
        data.push(
          new FormGroup({
            docTypeList: new FormArray(this.loadOtherDocType(item.documentDescriptionType, item)),
            docList: new FormArray(this.loadDocList(item.docList || [])),
            document: new FormControl(item.document),
            docName: new FormControl(item.docname),
            docPath: new FormControl(item.docpath),
            subtext: new FormControl(item.subtext),
            type: new FormControl(item.type),
            docId: new FormControl(item.docId || item.docid),
            kycId: new FormControl(item.kycId || 0),
            uploadSuccess: new FormControl(false),
            mandatory:new FormControl(item.mandatory),
          })
        );
      } else if (item.type == 'multi') {
        data.push(
          new FormGroup({
            docTypeList: new FormArray(this.loadMultiDocType(item.documentDescriptionType, item)),
            docList: new FormArray(this.loadDocList(item.docList || [])),
            document: new FormControl(item.document),
            docName: new FormControl(item.docname),
            docPath: new FormControl(item.docpath),
            subtext: new FormControl(item.subtext),
            type: new FormControl(item.type),
            docId: new FormControl(item.docId || item.docid),
            kycId: new FormControl(item.kycId || 0),
            uploadSuccess: new FormControl(false),
            mandatory:new FormControl(item.mandatory),
          })
        );
      } else {
        data.push(
          new FormGroup({
            docTypeList: new FormArray(this.loadSingleDocType(item.documentDescription, item)),
            docList: new FormArray(this.loadDocList(item.docList || [])),
            document: new FormControl(item.document),
            docName: new FormControl(item.docname),
            docPath: new FormControl(item.docpath),
            subtext: new FormControl(item.subtext),
            type: new FormControl(item.type),
            docId: new FormControl(item.docId || item.docid),
            kycId: new FormControl(item.kycId || 0),
            uploadSuccess: new FormControl(false),
            mandatory:new FormControl(item.mandatory),
          })
        );
      }

    })
    return data;
  }

  loadSingleDocType(docTypes: any, item: any) {
    // console.log("=====>Single===>", docTypes)

    let data: any = [];
    (Array.isArray(docTypes) ? docTypes : []).forEach((docType: any) => {
      if (docType !== '') {
        console.log("=====>Single===>", item.docType)
        console.log("=====>Single aaa===>", docType)
        data.push(
          new FormGroup({
            docList: new FormArray(this.loadDocList(item.docList || [])),
            docType: new FormControl(docType.docType || docType),
            docName: new FormControl(docType.docname || ''),
            docPath: new FormControl(docType.docpath || ''),
            type: new FormControl(docType.type || ''),
            docId: new FormControl(docType.docid || ''),
            kycId: new FormControl(docType.kycId || 0),
            isSelected: new FormControl(item.docType == docType ? docType : false),
            uploadSuccess: new FormControl(false),
            inputDisabled: new FormControl(true),
            mandatory:new FormControl(item.mandatory),
          })
        );
      }

    });
    return data;
  }

  loadMultiDocType(docTypes: any, item: any) {
    console.log("=====>Multi===>", docTypes)
    let data: any = [];
    (Array.isArray(docTypes) ? docTypes : []).forEach((docType: any) => {
      if (docType !== '') {
        data.push(
          new FormGroup({
            docList: new FormArray(this.loadDocList(docType.docList || [])),
            docType: new FormControl(docType.docType || docType),
            docName: new FormControl(docType.docname || ''),
            docPath: new FormControl(docType.docpath || ''),
            type: new FormControl(docType.type || ''),
            docId: new FormControl(docType.docid || ''),
            kycId: new FormControl(docType.kycId || 0),
            isSelected: new FormControl((docType.docList || []).length > 0 ? docType.docType : false),
            uploadSuccess: new FormControl(false),
            inputDisabled: new FormControl(docType.documentDescription.includes(docType.docType)),
            mandatory:new FormControl(item.mandatory),
          })
        );
      }
    });
    return data;
  }

  kycUploadFormSelect(type: string, selectedGroup: FormGroup, outIndex: number, innerIndex?: number, actionType = 'browse') {
    this.currentSelectedGroup = {
      outIndex,
      innerIndex,
      type,
      currentFormGroup: selectedGroup
    };
    this.merchantService.uploadKycBrowseButton(this.currentSelectedGroup);
    // console.log(selectedGroup)
  //  this.localDisableFlag = actionType == "view" ? true : this.isButtonDisable(outIndex, innerIndex)
    this.kycUploadModalConfig = {
      ...this.kycUploadModalConfig,
      modalTitle: `${selectedGroup?.get('document')?.value}`
    }
    this.kycUploadModal.open();
  }

  loadOtherDocType(docTypes: any, item: any) {
    // console.log("=====>Other===>", docTypes, item)
    let data: any = [];
    (Array.isArray(docTypes) ? docTypes : []).forEach((docType: any) => {
      if (docType !== '') {
        data.push(
          new FormGroup({
            docList: new FormArray(this.loadDocList(docType.docList || [])),
            docType: new FormControl(docType.docType || docType),
            docName: new FormControl(docType.docname || ''),
            docPath: new FormControl(docType.docpath || ''),
            type: new FormControl(docType.type || ''),
            docId: new FormControl(docType.docid || ''),
            kycId: new FormControl(docType.kycId || 0),
            isSelected: new FormControl((docType.docList || []).length > 0 ? docType.docType : false),
            uploadSuccess: new FormControl(false),
            inputDisabled: new FormControl(docType.documentDescription.includes(docType.docType)),
            mandatory:new FormControl(item.mandatory),
          })
        );
        // console.log("Other------->", data, item.docList)
      }
    });
    return data;
  }

  loadDocList(docTypes: any) {
    // console.log("=====>Other===>", docTypes)
    let data: any = [];
    (Array.isArray(docTypes) ? docTypes : []).forEach((docType: any) => {
      if (docType !== '') {
        data.push(
          this.addDocList(docType)
        );
      }
    });
    return data;
  }

  addOtherDocType(docTypes?: any) {
    return new FormGroup({
      docList: new FormArray([]),
      docType: new FormControl(''),
      docName: new FormControl(''),
      docPath: new FormControl(''),
      type: new FormControl(''),
      docId: new FormControl(''),
      kycId: new FormControl(0),
      isSelected: new FormControl(true),
      uploadSuccess: new FormControl(false),
      inputDisabled: new FormControl(false),
    });
  }

  addDocList(docType?: any) {
    return new FormGroup({
      docName: new FormControl(docType?.docname || docType?.docName || '', [Validators.required]),
      docPath: new FormControl(docType?.docpath || docType?.docPath || '', [Validators.required]),
      kycId: new FormControl(docType?.kycId || 0),
      isSelected: new FormControl(true),
      uploadSuccess: new FormControl(false)
    });
  }

  onFileSelect($event: any, i: number, docid: any, kycId: any, type?: string) {
debugger

    console.log("$event?.target.value:::"+$event?.target.value);
    console.log("docid:::"+docid);
    console.log("kycId:::"+kycId);
    console.log("type:::"+type);

    type = type || 'single'
    if ($event?.target?.files.length > 0) {
      const controls = this.merchantKycDataArr()[i];
      const docListControls = this.merchantKycDataArr()[i].get('docTypeList').controls;

      const file = $event.target.files[0];
      const fileProp = file.name?.split('.');

      // console.log("File--->", file);
      // console.log("FileProp--->", fileProp);
      if (!allowedExtensions.includes(fileProp[1])) {
        this.alertService.errorAlert({
          html: "Only PDF, PNG, JPG, JPEG, BMP, PNG files are allowed"
        })
        return false;
      } else {
        if (file) {
          const formData = new FormData();
          formData.append('imageFile', file);
          formData.append('merchantId', this.merchantId);
          formData.append("docType", "");
          formData.append('docId', docid);
          this.merchantService.uploadKycFile(formData)
            .subscribe((data: any) => {
              data.forEach((element: any) => {
                controls.patchValue({
                    "docId": docid,
                    "docName": element.docName,
                    "docPath": element.docpath,
                    // "doctype": docListControls.doctype.value || this.fileExtension,
                    "kycId": kycId || 0,
                    "type": type,
                    "uploadSuccess": true
                  }
                )

              });
            })
        }
        return true;
      }

    }
    return false;
  }


  onFileSelectMulti($event: any, i: number, docid: any, kycId: any, type: any, rad: number) {
    type = type || 'other'
    if ($event?.target?.files.length > 0) {
      const controls = this.merchantKycDataArr()[i].get('docTypeList').controls[rad];
      const docType = controls.get('docType').value
      // const docListControls = this.merchantKycDataArr()[i].get('docTypeList').controls;
      // const allowedExtensions = ["pdf", "PDF", "png", "PNG", "jpg", "JPG", "jpeg", "JPEG"];
      const file = $event.target.files[0];
      const fileProp = file.name?.split('.');

      // console.log("File--->", file);
      // console.log("FileProp--->", fileProp);
      if (!allowedExtensions.includes(fileProp[1])) {
        this.alertService.errorAlert({
          html: "Only " + "PDF" + "PNG" + "JPG" + "JPEG" + " files are allowed"
        })
        return false;
      } else {
        if (file) {
          const formData = new FormData();
          formData.append('imageFile', file);
          formData.append('merchantId', this.merchantId);
          formData.append("docType", docType || type);
          formData.append('docId', docid);
          this.merchantService.uploadKycFile(formData)
            .subscribe((data: any) => {
              data.forEach((element: any) => {
                controls.patchValue({
                    "docId": docid,
                    "docName": element.docName,
                    "docPath": element.docpath,
                    // "doctype": docListControls.doctype.value || this.fileExtension,
                    "kycId": kycId || 0,
                    "type": type,
                    "uploadSuccess": true
                  }
                )

              });
            })
        }
        return true;
      }

    }
    return false;
  }

  addCustomDocType(i: number, u: any) {
    const controls = this.merchantKycDataArr()[i];
    const docListControls = this.merchantKycDataArr()[i].get('docTypeList').controls;
    const length = docListControls.length;
    docListControls.push(this.addOtherDocType())
    this.getDocTypeList(i, length).updateValueAndValidity();
    this.onDocTypeChangeSingle(i, length);
    // console.log("Doc Listing---->",this.merchantKycDataArr()[i])
  }

  removeCustomDocType(index: number, inIndex: number) {
    debugger
    // this.loaderService.showLoader();
    const docTypeListControls = (this.merchantKycData.controls[index]?.get('docTypeList') as FormArray);
    const docListControls = (docTypeListControls?.controls[inIndex]?.get('docList') as FormArray)

    if (docListControls?.controls.length == 0) {
      docTypeListControls.removeAt(inIndex, {emitEvent: true})
      this.loaderService.hideLoader();
      return;
    }
    return this.alertService.confirmBox(
      async () => {
        console.log('________________=====>');
        this.loaderService.showLoader();
        return Promise.all(docListControls?.controls.map((ctrl) => {
          console.log(ctrl?.get('docPath')?.value,
            ctrl?.get('kycId')?.value,
            ctrl?.get('docName')?.value);
          return new Promise((resolve, reject) => {
            // setTimeout(() => {
            //   reject({
            //     docPath: ctrl?.get('docPath')?.value,
            //     kycId: ctrl?.get('kycId')?.value,
            //     docName: ctrl?.get('docName')?.value
            //   })
            // }, 2000)
            this.merchantService.deleteKycFile({
              merchantId: this.merchantId,
              path: ctrl?.get('docPath')?.value,
              id: ctrl?.get('kycId')?.value || 0,

              // docName: ctrl?.get('docName')?.value
            }).subscribe((respData) => {
              resolve(respData)

            }, (err) => {
              reject(err)
            })

          })
        }))
          .then((data) => {
            console.log(data);
            this.loaderService.hideLoader();
          }).catch(() => {
            console.log('Conf action catch');
            throw new Error('Conf action error')
          })
      },
      {
        html: `Are you sure to delete uploaded files?`
      },
      {
        html: "Files have been deleted successfully.!"
      },

      async () => {
        docTypeListControls.removeAt(inIndex, {emitEvent: true})
        this.loaderService.hideLoader();

        //   console.log("'''''---->", da)
        //   docTypeListControls.removeAt(inIndex, {emitEvent: true})
        //   this.loaderService.hideLoader();
      },
      async (err: any) => {
        this.loaderService.hideLoader();
        console.log("--->Error Action Log");
        console.log(err);
      })

  }

  addCustomDocList(i: number, u: any) {
    const controls = this.merchantKycDataArr()[i];
    const docListControls = this.merchantKycDataArr()[i].get('docList').controls;
    docListControls.push(this.addDocList())
  }

  async resetSelection($event: MouseEvent, i: number, u: any) {
    const docListControls = (this.merchantKycData.controls[i]?.get('docList') as FormArray);

    if (docListControls?.controls.length == 0) {
      console.log("Doc count 0");

      this.merchantKycDataArr()[i].get('docTypeList').controls.forEach((control: any, i: number) => {
        control.get('isSelected').patchValue(false);
      });
      this.onDocTypeChangeSingle(i);
      this.loaderService.hideLoader();
      return;
    } else if (docListControls?.controls.length > 0 && docListControls?.controls[0]?.get('docPath')?.value == '') {
      console.log("Doc Path Empty");
      this.merchantKycDataArr()[i].get('docTypeList').controls.forEach((control: any, i: number) => {
        control.get('isSelected').patchValue(false);
      });
      this.onDocTypeChangeSingle(i);
      this.loaderService.hideLoader();
      return;
    }

    console.log("Doc Delete");
    return this.alertService.confirmBox(
      async () => {
        this.loaderService.showLoader();
        return Promise.all(docListControls?.controls.map((ctrl, fileIndex) => {

          return new Promise((resolve, reject) => {
            this.merchantService.deleteKycFile({
              merchantId: this.merchantId,
              path: ctrl?.get('docPath')?.value,
              id: ctrl?.get('kycId')?.value || 0,
            }).subscribe((respData) => {
              docListControls.removeAt(fileIndex, {emitEvent: true});
              resolve(respData);
            }, (err) => {
              reject(err);
            });

          });
        }))
        .then((data) => {
          console.log(data);
          this.loaderService.hideLoader();
          this.ngOnInit();
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        }).catch(() => {
          console.log('Conf action catch');
          throw new Error('Conf action error');
        });
      },
      {
        html: `Are you sure to delete uploaded files?`
      },
      {
        html: "Files have been deleted successfully.!"
      },

      async () => {
        this.merchantKycDataArr()[i].get('docTypeList').controls.forEach((control: any, i: number) => {
          control.get('isSelected').patchValue(false);
        });
        this.onDocTypeChangeSingle(i);
        this.loaderService.hideLoader();

        this.getDocCount(u);
      },

      async (err: any) => {
        this.loaderService.hideLoader();
        console.log("--->Error Action Log");
        console.log(err);
      }
    );
  }


  downloadFileService(docname: any, docpath: any) {
    let fileType = docname.split('.').pop();
    let fileInitial = docname.split('.')[0]
    const formData = new FormData();
    formData.append('mid', this.merchantId);
    formData.append('docname', docname);
    this.merchantService.downloadKycFile(formData)
      .subscribe((res: any) => {
        const response = res;
        const random = Math.floor(Math.random() * 10000000000 + 1);

        const today = new Date();

        const linkSource = 'data:application/' + fileType + ';base64,' + response.Data;
        const downloadLink = document.createElement("a");
        const NewfileName = "Merchant_Doc_" + today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) +"-"+ ("0" + today.getDate()).slice(-2) + "-" + random.toString().slice(-4) + fileInitial + "." + fileType;

        downloadLink.href = linkSource;
        downloadLink.download = NewfileName;
        downloadLink.click();
      })

  }

  viewFileService(docname: any, docpath: any) {
    let fileType = docname.split('.').pop();
    let fileInitial = docname.split('.')[0]
    const formData = new FormData();
    formData.append('mid', this.merchantId);
    formData.append('docname', docname);
    return new Promise((resolve, reject) => {
      this.merchantService.downloadKycFile(formData)
        .subscribe((res) => {
          // const size = res.headers.get('Content-Length')
          const sizeInBytes = 4 * Math.ceil((res?.Data?.length / 3)) * 0.5624896334383812;
          const sizeInKb = sizeInBytes / 1000;
          console.log(sizeInKb, this.detectBrowserName(), "======++++++++++++===>");
          if (!res?.Data) {
            return reject(res);
          }

          const linkSource = 'data:application/' + fileType + ';base64,' + res?.Data;
          let temp_url;
          if (sizeInKb > 1024) {
            const blob = this.dataURLtoBlob(linkSource);
            temp_url = window.URL.createObjectURL(blob);
          }


          this.kycFileSrc = {
            type: fileType == 'pdf' ? 'FILE' : 'IMAGE',
            src: this.sanitizer.bypassSecurityTrustResourceUrl(temp_url || linkSource)
          }
          return resolve(this.kycFileSrc);
        })
    })


  }

  deleteFileService(docpath: any, kycId: any, docname: any) {
    const formData = {
      "merchantId": this.merchantId,
      "path": docpath,
      "id": kycId || 0
    }
    return this.alertService.confirmBox(this.merchantService.deleteKycFile(formData), {
      html: `Are you sure to delete <b>${docname}</b>`
    }, {
      html: "File has been deleted successfully.!"
    }, async () => {
      // await this.setKycData();
      this.currentSelectedGroup = {
        ...this.currentSelectedGroup,
        currentFormGroup: this.merchantKycDataArr()[this.currentSelectedGroup.outIndex]
      };
      this.merchantService.uploadKycBrowseButton(this.currentSelectedGroup);
    });
  }

  onRadioSelect($event: Event, i: number, rad: number, radio: any, docType?: any, docId?: any) {
    this.merchantKycDataArr()[i].get('docTypeList').controls.forEach((control: any, i: number) => {
      if (rad !== i) control.get('isSelected').patchValue(false)
    })

    this.onDocTypeChangeSingle(i);
  }


  getSubDocError(i: number, rad: number, docid: any, radio: any) {
    return false;
  }

  private hasAtLeastOneUbo(): boolean {
    return (this.UBOList?.length || 0) > 0 || (this.formArray?.length || 0) > 0;
  }

  submitKycData($event: MouseEvent, value: any) {
    debugger;
    const allow_wavier = this.allKycDataFormGroup.get('isWavier')?.value;
    const wavier_date = this.allKycDataFormGroup.get('wavierOffDate')?.value;
    const wavier_remark = this.allKycDataFormGroup.get('wavierRemarks')?.value;

    console.log(allow_wavier, wavier_date, wavier_remark);
    $event.preventDefault();
    this.isKycFormSubmitted = true;

    if (!this.hasAtLeastOneUbo()) {
      this.alertService.errorAlertWithMessage('Add the shareholders/Partners/UBO details of the entity to proceed');
      return;
    }

    const finalData: any[] = [];
    const missingDocuments: string[] = [];
    this.merchantKycDetails.forEach((doc: any) => {
      if (doc.mandatory === 'Y') {
        const formDoc = this.allKycDataFormGroup.get('merchantKycData')?.value.find((formDocData: any) => formDocData.docId === doc.docid);
        if (!formDoc || !formDoc.docList || formDoc.docList.length === 0 || formDoc.docList.every((d: any) => !d.docName)) {
          missingDocuments.push(doc.document);
        }
      }
    });

    // If there are missing mandatory documents, stop further processing
    if (missingDocuments.length > 0) {
      return; // The inline error messages will handle the display
    }

    // Process the form if no mandatory document is missing
    if (this.isKycValid()) {
      debugger;
      this.merchantKycDataArr().forEach((l1Control: FormGroup) => {
        if (l1Control.get('type')?.value === 'single') {
          (l1Control.get('docList') as FormArray)?.controls.forEach((l3Control) => {
            const fileSplit = l3Control.value?.docName.split('.');
            finalData.push({
              "documentId": this.documentId,
              "docid": l1Control.get('docId')?.value,
              "docname": l3Control.value?.docName || '',
              "docpath": l3Control.value?.docPath || '',
              "doctype": l1Control.get('docTypeList')?.value?.find((dtl: any) => dtl.isSelected)?.docType || (fileSplit.length > 0 ? fileSplit[fileSplit.length - 1] : 'default'),
              "kycid": l3Control.value?.kycId || 0,
              "allow_Wavier": this.allKycDataFormGroup.get('isWavier')?.value ? 'Y' : 'N',
              "wavier_date": this.allKycDataFormGroup.get('wavierOffDate')?.value || '',
              "wavier_remark": this.allKycDataFormGroup.get('wavierRemarks')?.value || '',
              "type": "single"
            });
          });
        } else if (['multi', 'other'].includes(l1Control.get('type')?.value)) {
          (l1Control.get('docTypeList') as FormArray).controls.forEach((value: AbstractControl, index: number) => {
            const l2Control = value as FormGroup; // Type assertion here
            const currentDocType = l2Control.get('docType')?.value;
            (l2Control.get('docList') as FormArray)?.controls.forEach((l4Control) => {
              if (l2Control.get('isSelected')?.value) {
                const fileSplit = l4Control.value?.docName.split('.');
                finalData.push({
                  "documentId": this.documentId,
                  "docid": l1Control.get('docId')?.value,
                  "docname": l4Control.value?.docName || '',
                  "docpath": l4Control.value?.docPath || '',
                  "doctype": currentDocType,
                  "kycid": l4Control.value?.kycId || 0,
                  "allow_Wavier": this.allKycDataFormGroup.get('isWavier')?.value ? 'Y' : 'N',
                  "wavier_date": this.allKycDataFormGroup.get('wavierOffDate')?.value || '',
                  "wavier_remark": this.allKycDataFormGroup.get('wavierRemarks')?.value || '',
                  "type": "multi"
                });
              }
            });
          });
        }
      });
      this.merchantService.uploadKycDocsData(this.merchantId, finalData)
      .subscribe((data) => {
        if (data) {
          this.alertService.successAlert('KYC documents Submitted Successfully!', '');
          this.setKycData();
        }
      })
    }
  }


  isButtonDisable(i: number, rad?: number | undefined) {

    let status = true;
    const controls = this.merchantKycDataArr()[i].get('docTypeList').controls;
    if (!isNaN(<number>rad)) {
      // @ts-ignore
      const control = this.merchantKycDataArr()[i].get('docTypeList').controls[rad];
      const val = control.get('isSelected').value;
      if (val) {
        status = false
      }
      return status;
    }
    if (controls.length == 0) return false;
    controls.forEach((control: any, ind: number) => {
      const val = control.get('isSelected').value;
      if (val) {
        status = false
      }
    })
    return status;
  }

  statusApproval(status: number) {
    let appRequestBody;
    let responseMsg: string;
    const remarks = this.kycApprovalForm.controls['remarks'].value;
    // return;
    if (remarks.trim() == '') {
      // this.errorRemarks = 1;
      this.alertService.errorAlert({
        text: "Please enter remarks"
      });
      return false;
    }

    if (this.kycApprovalForm.valid) {
      if (status == 1) {
        responseMsg = "Kyc Successfully approved";
        appRequestBody = {
          "type" : "M",
          "userId": this.merchantId,
          "appStatus" : "Approved",
          "appRemark": remarks,
          "appType": "KYC"
        }
      } else {
        responseMsg = "Kyc Successfully rejected";
        appRequestBody = {
          "type" : "M",
          "userId": this.merchantId,
          "appStatus" : "Rejected",
          "appRemark": remarks,
          "appType": "KYC"

        }
      }

      // this.merchantService.sendApproval(appRequestBody)
      //   .subscribe(
      //     (data) => {
      //       if (data?.length > 0) {
      //         this.status = data[0]['kyc_approvel']
      //         if (this.status != 0)
      //           this.kycApprovalForm.controls['remarks'].disable();
              // this.alertService.toastSuccessMessageAlert({
              //   title: responseMsg
              // })

              this.merchantService.saveOnboardingRemark(appRequestBody).subscribe((response)=>{
              console.log(response);
              if(response.response.message == "Onboarding remark added successfully"){
              // this.merchantService.getRiskRemark(this.merchantId, 'M', 'Kyc')
              //   .subscribe((data: any) => {
              //       this.remarkData = data
              //       this.dataTable ? this.dataTable.destroy() : console.log(this.remarkData)
              //       this.remarkData ? this.dataTable = new DataTable("#dataTableExample") : this.dataTable.destroy()
              //       if (this.remarkData) {
              //         this.remarkData.forEach((element: any) => {
              //           this.dataTable.rows().add(Object.values(element));
              //         })
              //       }
              //     }
              //   )

              this.merchantService.getOnboardingRemark(this.merchantId,"KYC").subscribe((response)=>{

                if(response.response.data.length > 0){
                  this.remarkData = response.response.data;
                }
              })

              this.alertService.successAlert(responseMsg)
          //   } else {
          //     this.alertService.errorAlert({
          //       text: "Some error occurred"
          //     })
          //   }

          // },
          // (error) => {
          //   this.alertService.errorAlert()
          // }
        // )
      }else{
        this.alertService.errorAlertWithMessage(response.response.message)
      }
      })
      return true;
    }
    if (remarks.trim() == '') {
      // this.errorRemarks = 1;
      this.alertService.errorAlert({
        text: "Please enter remarks"
      })
      return true;
    }
    // this.errorRemarks = 0;
    return true;
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  dataURLtoBlob(dataurl: string) {
    let arr = dataurl.split(',') || [];
    // @ts-ignore
    let mime = arr[0]?.match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
  }

  // ------------------- UBO ---------------------------

  get formArray(): FormArray {
    return this.formGroup.get('formArray') as FormArray;
  }

  get forms() {
    return this.formArray.controls as FormGroup[];
  }

  createFormIndividual(): FormGroup {
    return this.formBuilder.group({
      id : [null],
      entityId : [this.merchantId,[Validators.required]],
      shareHolderName: ['', [Validators.required]],
      shareHolderPercentage: ['', [Validators.required,Validators.max(100)]],
      shareHolderOf: [null,[Validators.required]],
      parentId : [null],
      roleInEntity : [null,[Validators.required]],
      typeOfShareHolder: [null,Validators.required],
      nationality: [null, Validators.required],
      nationalityCode:[''],
      dateOfBirth: [null,Validators.required],
      countryOfResidence: [null,Validators.required],
      placeOfBirth: [null,Validators.required],
      dualNationality: [null],
      secondNationality: [null],
      nationalityColor:['background-color: #e9ecef'],
      eid: ['', [Validators.pattern(this.eidRegex)]],
      eidIssueDate: [''],
      eidExpiryDate: [''],
      passportIssueCountry: [null,Validators.required],
      passportNumber: ['', [Validators.required,Validators.pattern(/^[A-Za-z0-9]{6,9}$/)]],
      passportIssueDate: ['', Validators.required],
      passportExpiryDate: ['', Validators.required],
      address: [''],
      mobileNumber: ['',[Validators.required,Validators.pattern(/^\+?[1-9]\d{8,14}$/)]],
      emailId: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],
      pepFlag: ["NO"],
      pepCategory: [''],
      document: [''],
      documentList : [null],
      newFileName : [null],
      oldDocument :[null],
    });
  }

  createFormPOA(): FormGroup {
    return this.formBuilder.group({
      id : [null],
      entityId : [this.merchantId,[Validators.required]],
      shareHolderName: ['', [Validators.required]],
      parentId : [null],
      roleInEntity : ['',[Validators.required]],
      typeOfShareHolder: [null,Validators.required],
      nationality: [null, Validators.required],
      nationalityCode:[''],
      dateOfBirth: [null,Validators.required],
      countryOfResidence: [null,Validators.required],
      placeOfBirth: [null,Validators.required],
      dualNationality: [null],
      secondNationality: [null],
      nationalityColor:['background-color: #e9ecef'],
      eid: ['', [Validators.pattern(this.eidRegex)]],
      eidIssueDate: [''],
      eidExpiryDate: [''],
      passportIssueCountry: [null,Validators.required],
      passportNumber: ['', [Validators.required,Validators.pattern(/^[A-Za-z0-9]{6,9}$/)]],
      passportIssueDate: ['', Validators.required],
      passportExpiryDate: ['', Validators.required],
      address: [''],
      mobileNumber: ['',[Validators.required,Validators.pattern(/^\+?[1-9]\d{8,14}$/)]],
      emailId: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],
      pepFlag: ["NO"],
      pepCategory: [''],
      document: [''],
      documentList : [null],
      newFileName : [null],
      oldDocument :[null],
    });
  }


  createFormEntity(): FormGroup {
    return this.formBuilder.group({
      id : [null],
      entityId : [this.merchantId,[Validators.required]],
      parentId : [null],
      shareHolderOf : ['',[Validators.required]],
      shareHolderPercentage : ['',[Validators.required]],
      roleInEntity : [null,[Validators.required]],
      typeOfShareHolder : [''],
      shareHolderName : ['',[Validators.required]],
      registrationNumber : [''],
      countryOfIncorporation : [null],
      dateOfIncorporation : [null],
      companyType : [null,[Validators.required]],
      address : [''],
      natureOfBusiness : ['',[Validators.required]],
      idType : [null,[Validators.required]],
      idNumber : ['',[Validators.required]],
      idIssueDate : ['',[Validators.required]],
      idExpiryDate : [null],
      document: [''],
      documentList : [null],
      newFileName : [null],
      oldDocument :[null],
      entityTotalPercentage : ['']
    });
  }

  addForm(data?:any) {
    this.setAllTypeUBO(data.typeOfShareHolder,data);
  }


  openType(){
    const inputOptions: any = {
      Individual: 'Individual',
      Entity: 'Entity',
    };
    // Check if POA already exists in UBOList
    // this.hasPOA = this.UBOList?.some((ubo: any) => ubo.typeOfShareHolder === 'POA');

    // Only add POA if it's not already present
    if (!this.hasPOA) {
      inputOptions.POA = 'POA';
    }

    if(this.totalPercentage >= 100){
      delete inputOptions.Individual;
      delete inputOptions.Entity;
    }
    Swal.fire({
      title: 'Related Parties',
      input: 'select',
      inputOptions: inputOptions,
      inputPlaceholder: 'Choose an option',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to select the type of shareholder!';
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedValue = result.value;
        console.log('Selected:', selectedValue);
        this.setAllTypeUBO(selectedValue);
      }
    });
  }

  setAllTypeUBO(type : any,data?:any,parentData?:any){
    console.log(type)
    console.log(data)
    if(type == "Individual"){
      console.log("Creating Individual Form")
      const form = this.createFormIndividual();
      if (data) {
      form.patchValue(data);
      }else{
        this.enableAddButton = false;
        if(parentData){
          form.get('typeOfShareHolder')?.setValue(type);
          form.get('shareHolderOf')?.setValue(parentData.value.shareHolderName);
          form.get('parentId')?.setValue(parentData.value.id);
        }else{
          form.get('typeOfShareHolder')?.setValue(type);
          form.get('shareHolderOf')?.setValue(this.merchantDetails.response.data.legalName);
        }
      }
      if(form.value.dualNationality == "YES"){
        form.get('secondNationality')?.enable();
        form.get('nationalityColor')?.setValue('');
      }else{
        form.get('secondNationality')?.disable();
      }
      if(form.value.pepFlag == "YES"){
        form.get('pepCategory')?.enable();
      }else{
        form.get('pepCategory')?.disable();
      }
      if(form.get('countryOfResidence')?.value != defaultCountryName){
        form.get('eid')?.disable();
        form.get('eidIssueDate')?.disable();
        form.get('eidExpiryDate')?.disable();
      }else{
        const eidControl = form.get('eid');
        const eidIssueDateControl = form.get('eidIssueDate');
        const eidExpiryDateControl = form.get('eidExpiryDate');

        eidControl?.setValidators([
          Validators.required,
          Validators.pattern(this.eidRegex)
        ]);
        eidIssueDateControl?.setValidators([
          Validators.required,
        ]);
        eidExpiryDateControl?.setValidators([
          Validators.required,
        ]);

        eidControl?.updateValueAndValidity();
        eidIssueDateControl?.updateValueAndValidity();
        eidExpiryDateControl?.updateValueAndValidity();
        form.get('eid')?.enable();
        form.get('eidIssueDate')?.enable();
        form.get('eidExpiryDate')?.enable();
      }
      this.formArray.push(form);
    }else if(type == "POA"){
      console.log("Creating POA Form")
      const form = this.createFormPOA();
      if (data) {
      form.patchValue(data);
      }else{
        this.enableAddButton = false;
        form.get('roleInEntity')?.setValue('POA');
        form.get('typeOfShareHolder')?.setValue(type);
      }
      if(form.value.dualNationality == "YES"){
        form.get('secondNationality')?.enable();
        form.get('nationalityColor')?.setValue('');
      }else{
        form.get('secondNationality')?.disable();
      }
      if(form.value.pepFlag == "YES"){
        form.get('pepCategory')?.enable();
      }else{
        form.get('pepCategory')?.disable();
      }
      if(form.get('countryOfResidence')?.value != defaultCountryName){
        form.get('eid')?.disable();
        form.get('eidIssueDate')?.disable();
        form.get('eidExpiryDate')?.disable();
      }else{
        const eidControl = form.get('eid');
        const eidIssueDateControl = form.get('eidIssueDate');
        const eidExpiryDateControl = form.get('eidExpiryDate');

        eidControl?.setValidators([
          Validators.required,
          Validators.pattern(this.eidRegex)
        ]);
        eidIssueDateControl?.setValidators([
          Validators.required,
        ]);
        eidExpiryDateControl?.setValidators([
          Validators.required,
        ]);

        eidControl?.updateValueAndValidity();
        eidIssueDateControl?.updateValueAndValidity();
        eidExpiryDateControl?.updateValueAndValidity();
        form.get('eid')?.enable();
        form.get('eidIssueDate')?.enable();
        form.get('eidExpiryDate')?.enable();
      }
      this.formArray.push(form);
    }else if(type == "Entity"){
      console.log("Creating Entity Form")
      const form = this.createFormEntity();
      if (data) {
      form.patchValue(data);
      }else{
        this.enableAddButton = false;
         if(parentData){
          form.get('typeOfShareHolder')?.setValue(type);
          form.get('shareHolderOf')?.setValue(parentData.value.shareHolderName);
          form.get('parentId')?.setValue(parentData.value.id);
        }else{
          form.get('typeOfShareHolder')?.setValue(type);
          form.get('shareHolderOf')?.setValue(this.merchantDetails.response.data.legalName);
        }
      }
      if(form.get('idType')?.value == "Certificate of Incorporation"){
        form.get('idExpiryDate')?.disable();
      }else{
        form.get('idExpiryDate')?.enable();
        const idExpiryControl = form.get('idExpiryDate');
        idExpiryControl?.setValidators([
          Validators.required
        ]);
        idExpiryControl?.updateValueAndValidity();
      }
      this.formArray.push(form);
    }
  }

  addChildUBO(row:any){
    const form = this.formArray.at(row);
    Swal.fire({
      title: 'Related Parties',
      input: 'select',
      inputOptions: {
        Individual: 'Individual',
        Entity: 'Entity',
      },
      inputPlaceholder: 'Choose an option',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to select the type of shareholder!';
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedValue = result.value;
        console.log('Selected:', selectedValue);
        this.setAllTypeUBO(selectedValue,null,form);

      }
    });
  }

    //Soft remove the Owner from the Form if the id is not present
  removeForm(index: number) {
    if (this.formArray.length > 0) {
      this.formArray.removeAt(index);
      this.enableAddButton = true;
    } else {
      this.alertService.errorAlertWithMessage("At least one form is required.");
    }
  }

  idTypeChange(idType:any,row:any){
    console.log(idType)
    const form = this.formArray.at(row);
    const idExpiryControl = form.get('idExpiryDate');
    if(idType === "Certificate of Incorporation"){
      idExpiryControl?.setValidators([]);
      form.get('idExpiryDate')?.disable();
    }else{
      form.get('idExpiryDate')?.enable();
      idExpiryControl?.setValidators([
        Validators.required
      ]);
    }
    idExpiryControl?.updateValueAndValidity();
  }


  //Actual Delete the Owner by API Call if the id is present
  async deleteOwner(UBOId:any){
    console.log(UBOId)
    //Call delete API for soft deleting the UBO
    await Swal.fire({
      title: "Are you sure ?",
      text: "You want to delete this UBO",
      confirmButtonText: '<span id="confirm-button-text">Delete</span>',
      showCancelButton: true,
      reverseButtons: false,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#7987a1',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.merchantService.deleteUBO(UBOId).subscribe((response:any)=>{
          console.log(response);
          if(response.response.httpStatus == "OK"){
            Swal.fire(response.response.message,'','success');
            this.fetchUBODetails();
            return;
          }else{
            Swal.fire(response.response.message,'','error');
            this.fetchUBODetails();
            return;
          }
        })
        Swal.fire('Error while deleting the UBO','','error');
        }
      });
  }

  //After submitting, the screening will start for all the UBO's
  async submitAllUBO(){
    console.log(this.merchantId)
      await Swal.fire({
        title: "Are you sure ?",
        text: "You want to Submit all UBO Details",
        confirmButtonText: '<span id="confirm-button-text">Submit</span>',
        showCancelButton: true,
        reverseButtons: false,
        confirmButtonColor: '#dfa111',
        cancelButtonColor: '#7987a1',
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom'
        },
      }).then((result) => {
        if (result.isConfirmed) {
            if(this.merchantId != undefined){
              this.merchantService.submitUBOForScreening(this.merchantId).subscribe((response:any)=>{
              console.log(response);
              if(response.response.httpStatus == "OK"){
                Swal.fire(response.response.data+" "+response.response.message,'','success');
                this.fetchUBODetails();
                return;
              }else{
                Swal.fire(response.response.message,'','error');
                this.fetchUBODetails();
                return;
              }
              })
            }
          }
        });
  }


  //Save the single UBO
  submitForms(row:number) {
    const form = this.formArray.at(row);
    console.log('Submitted Data:', form);
    this.getDocumentErrorMessage(row);
    if (form.valid) {
      if(form.value.parentId != null){
        if(form.value.shareHolderPercentage < 25){
          this.alertService.toastWarringMessageAlertWithMessage("Shareholder Percentage cannot be less than 25")
          return;
        }
      }
      //Call save API for saving the Owner
      let request : any ={
        "id" : form.value.id,
        "entityId" : form.value.entityId,
        "parentId" : form.value.parentId,
        "shareHolderName" : form.value.shareHolderName,
        "shareHolderPercentage" : form.value.shareHolderPercentage,
        "shareHolderOf" : form.value.shareHolderOf,
        "roleInEntity" : form.value.roleInEntity,
        "typeOfShareHolder" : form.value.typeOfShareHolder,
        "countryOfResidence" : form.value.countryOfResidence,
        "nationality" : form.value.nationality,
        "nationalityCode" : form.value.nationalityCode,
        "placeOfBirth" : form.value.placeOfBirth,
        "dateOfBirth" : this.ngbDateParserFormatter.format(form.value.dateOfBirth),
        "dualNationality" : (form.value.dualNationality==="YES"?true : false),
        "secondNationality" : form.value.secondNationality,
        "eid" : form.value.eid?.replace(/[^0-9]/g, '') || '',
        "eidIssueDate" : this.ngbDateParserFormatter.format(form.value.eidIssueDate),
        "eidExpiryDate" : this.ngbDateParserFormatter.format(form.value.eidExpiryDate),
        "passportNumber" : form.value.passportNumber,
        "passportIssueCountry" : form.value.passportIssueCountry,
        "passportIssueDate" : this.ngbDateParserFormatter.format(form.value.passportIssueDate),
        "passportExpiryDate" : this.ngbDateParserFormatter.format(form.value.passportExpiryDate),
        "address" : form.value.address,
        "mobileNumber" : form.value.mobileNumber,
        "emailId" : form.value.emailId,
        "pepFlag" : (form.value.pepFlag==="YES"?true : false),
        "pepCategory" : form.value.pepCategory,
        "countryOfIncorporation" : form.value.countryOfIncorporation,
        "dateOfIncorporation" : this.ngbDateParserFormatter.format(form.value.dateOfIncorporation),
        "registrationNumber" : form.value.registrationNumber,
        "companyType" : form.value.companyType,
        "natureOfBusiness" : form.value.natureOfBusiness,
        "idType" : form.value.idType,
        "idNumber" : form.value.idNumber,
        "idIssueDate" : this.ngbDateParserFormatter.format(form.value.idIssueDate),
        "idExpiryDate" : this.ngbDateParserFormatter.format(form.value.idExpiryDate),
      }
      console.log(JSON.stringify(request));
      var requestData = new FormData();
      console.log(form.value.document)
      if(form.value.document != null){
        for(var i=0;i<form.value.document.length;i++){
          requestData.append("document",form.value.document[i]);
        }
      }
      requestData.append("uboData",JSON.stringify(request));
      this.merchantService.saveUBO(requestData).subscribe((response:any)=>{
        console.log(response);
        if(response.response.httpStatus == "OK"){
          Swal.fire(response.response.message,'','success')
          this.fetchUBODetails();
          this.enableAddButton = true;
          return;
        }else{
          Swal.fire(response.response.message,'','error')
          return
        }
      })
    } else {
      form.markAllAsTouched();
    }
  }

  changeDate(fromDate:any,row:any){
    this.currentDateUBO = fromDate
    this.minDate = fromDate;

    const form = this.formArray.at(row);
    if(form.get('typeOfShareHolder')?.value == 'Entity'){
      form.get('idExpiryDate')?.setValue(null);
    }else{
      form.get('eidExpiryDate')?.setValue(null);
    }
  }

  changeEndDate(toDate:any){
    this.currentDateUBO = toDate;
    // this.maxDateFrom = toDate;
  }

  changeDatePassportIssue(fromDate:any,row:any){
    this.currentDateUBOPassport = fromDate
    this.minDatePassport = fromDate;

    const form = this.formArray.at(row);
    form.get('passportExpiryDate')?.setValue(null);
  }

  changeDatePassportExpiry(toDate:any){
    this.currentDateUBOPassport = toDate;
    // this.maxDateFromPassport = toDate;
  }

  //Setting the Saved UBO in the forms
  fetchUBODetails(){
    console.log(this.merchantId)
    this.merchantService.getUBO(this.merchantId).subscribe((response:any)=>{
      console.log(response);
      this.UBOList = response.response.data.data;
      this.totalPercentage = response.response.data.totalPercentage;
      this.showFinalButton = response.response.data.screeningFlag;
      this.updateHasPOA();
      if(!this.permissions.includes('Add')){
        this.showFinalButton = false;
      }
      if(this.UBOList.length != 0){
        this.formArray.clear();
        this.UBOList.forEach(UboDetail => {
          this.setDocumentsByApi(UboDetail?.documents).then(file => {
            if(UboDetail.typeOfShareHolder == "Individual"){
              this.addForm({
              id : UboDetail.id,
              entityId : UboDetail.entityId,
              shareHolderName : UboDetail.shareHolderName,
              shareHolderPercentage : UboDetail.shareHolderPercentage,
              shareHolderOf : UboDetail.shareHolderOf,
              roleInEntity :  UboDetail.roleInEntity,
              nationality : UboDetail.nationality,
              nationalityCode: UboDetail.nationalityCode,
              parentId :  UboDetail.parentId,
              typeOfShareHolder : UboDetail.typeOfShareHolder,
              countryOfResidence: UboDetail.countryOfResidence,
              placeOfBirth: UboDetail.placeOfBirth,
              dateOfBirth : UboDetail?.dateOfBirth? this.setDateFromString(UboDetail?.dateOfBirth) : null,
              dualNationality : (UboDetail.dualNationality===true?"YES" : "NO"),
              secondNationality : UboDetail.secondNationality,
              eid:  this.formatEmiratesIdForDisplay(UboDetail?.eid),
              eidIssueDate:  UboDetail?.eidIssueDate? this.setDateFromString(UboDetail?.eidIssueDate) : null,
              eidExpiryDate: UboDetail?.eidExpiryDate? this.setDateFromString(UboDetail?.eidExpiryDate) : null,
              passportNumber : UboDetail.passportNumber,
              passportIssueCountry : UboDetail.passportIssueCountry,
              passportIssueDate : UboDetail?.passportIssueDate? this.setDateFromString(UboDetail?.passportIssueDate) : null,
              passportExpiryDate : UboDetail?.passportExpiryDate? this.setDateFromString(UboDetail?.passportExpiryDate) : null,
              address : UboDetail.address,
              mobileNumber : UboDetail.mobileNumber,
              emailId :UboDetail.emailId,
              pepFlag : (UboDetail.pepFlag===true?"YES" : "NO"),
              pepCategory : UboDetail.pepCategory,
              oldDocument : file,
              documentList : UboDetail?.documents
            });
            }else if(UboDetail.typeOfShareHolder == "Entity"){
              this.addForm({
              id : UboDetail.id,
              entityId : UboDetail.entityId,
              shareHolderName : UboDetail.shareHolderName,
              shareHolderPercentage : UboDetail.shareHolderPercentage,
              shareHolderOf: UboDetail.shareHolderOf,
              roleInEntity :  UboDetail.roleInEntity,
              parentId :  UboDetail.parentId,
              typeOfShareHolder : UboDetail.typeOfShareHolder,
              registrationNumber:  UboDetail.registrationNumber,
              countryOfIncorporation: UboDetail.countryOfIncorporation,
              dateOfIncorporation: UboDetail?.dateOfIncorporation? this.setDateFromString(UboDetail.dateOfIncorporation) : null,
              companyType:  UboDetail.companyType,
              idType : UboDetail.idType,
              idNumber : UboDetail.idNumber,
              idIssueDate: UboDetail?.idIssueDate? this.setDateFromString(UboDetail.idIssueDate) : null,
              idExpiryDate: UboDetail?.idExpiryDate? this.setDateFromString(UboDetail.idExpiryDate) : null,
              address: UboDetail.address,
              natureOfBusiness:  UboDetail.natureOfBusiness,
              oldDocument : file,
              documentList : UboDetail?.documents,
              entityTotalPercentage : UboDetail?.entityTotalPercentage,
            });
            }else if(UboDetail.typeOfShareHolder == "POA"){
              this.addForm({
              id : UboDetail.id,
              entityId : UboDetail.entityId,
              shareHolderName : UboDetail.shareHolderName,
              nationality : UboDetail.nationality,
              nationalityCode: UboDetail.nationalityCode,
              parentId :  UboDetail.parentId,
              roleInEntity :  UboDetail.roleInEntity,
              typeOfShareHolder : UboDetail.typeOfShareHolder,
              countryOfResidence: UboDetail.countryOfResidence,
              placeOfBirth: UboDetail.placeOfBirth,
              dateOfBirth : UboDetail?.dateOfBirth? this.setDateFromString(UboDetail?.dateOfBirth) : null,
              dualNationality : (UboDetail.dualNationality===true?"YES" : "NO"),
              secondNationality : UboDetail.secondNationality,
              eid:  UboDetail?.eid,
              eidIssueDate:  UboDetail?.eidIssueDate? this.setDateFromString(UboDetail?.eidIssueDate) : null,
              eidExpiryDate: UboDetail?.eidExpiryDate? this.setDateFromString(UboDetail?.eidExpiryDate) : null,
              passportNumber : UboDetail.passportNumber,
              passportIssueCountry : UboDetail.passportIssueCountry,
              passportIssueDate : UboDetail?.passportIssueDate? this.setDateFromString(UboDetail?.passportIssueDate) : null,
              passportExpiryDate : UboDetail?.passportExpiryDate? this.setDateFromString(UboDetail?.passportExpiryDate) : null,
              address : UboDetail.address,
              mobileNumber : UboDetail.mobileNumber,
              emailId :UboDetail.emailId,
              pepFlag : (UboDetail.pepFlag===true?"YES" : "NO"),
              pepCategory : UboDetail.pepCategory,
              oldDocument : file,
              documentList : UboDetail?.documents
            });
            }
          });
        });
      }
    })
  }

  setDateFromString(dateString: any) {
    if(dateString != undefined){
      const parts = dateString.split('-');
      console.log(parts)
      return this.model = {
        year: +parseInt(parts[0]),
        month: +parseInt(parts[1]),
        day: +parseInt(parts[2])
      };
    }
    return '';
  }

  fetchCountryList(){
    this.countryService.getCountryListAll("", "", "", "", "ALL", 0).subscribe((response: any) => {
      console.log(response);
      if(response && response.response && response.response.data && response.response.data.content){
        this.countryListDropdown = response.response.data.content.map( (_ : any) => {
          return {
            name: _.name,
            code: _.code
          }
        });
      }
    })
  }

  disabledDropdown(data:any,row:number){
    const form = this.formArray.at(row);
    if(data == "YES"){
      form.get('secondNationality')?.enable();
      form.get('nationalityColor')?.setValue('');
    }else{
      form.get('secondNationality')?.disable();
      form.get('nationalityColor')?.setValue('background-color: #e9ecef');
    }
    form.get('secondNationality')?.reset();
  }

  disabledPepDropdown(data:any,row:number){
    const form = this.formArray.at(row);
    if(data == "YES"){
      form.get('pepCategory')?.enable();
    }else{

      form.get('pepCategory')?.disable();
    }
    form.get('pepCategory')?.reset();
  }


  // onFileChange(event: Event, row: number) {
  //   const form = this.formArray.at(row);

  //   if (!form) {
  //     console.error(`Form at row ${row} is undefined`);
  //     return;
  //   }

  //   const input = event.target as HTMLInputElement;
  //   const file = input.files?.[0];

  //   if (!file) return;

  //   // Check file type (Allow only PDF or images)
  //   if (!(file.type === 'application/pdf' || file.type.startsWith('image/'))) {
  //     Swal.fire('Only PDF or image files are allowed.', '', 'error');
  //     this.resetFileInput(input);
  //     return;
  //   }

  //   // Check file size (should be ≤ 50 KB)
  //   if (file.size > 1 * 1024 * 1024) {
  //     Swal.fire('Document size cannot be greater than 1 MB', '', 'error');
  //     this.resetFileInput(input);
  //     return;
  //   }

  //   // this.fileName = file.name;

  //   if (this.fileUrl) {
  //     URL.revokeObjectURL(this.fileUrl);
  //   }
  //   this.fileUrl = URL.createObjectURL(file);

  //   const documentControl = form.get('document');
  //   const documentControlFileName = form.get('newFileName');
  //   if (!documentControl) {
  //     console.error(`'document' control is missing in form at row ${row}`);
  //     return;
  //   }
  //   console.log(file)
  //   documentControl.setValue(file);
  //   documentControlFileName?.setValue(file.name);

  //   // Read file as Data URL
  //   const reader = new FileReader();
  //   reader.onload = () => console.log('File successfully read');
  //   reader.onerror = (error) => console.error('Error reading file:', error);
  //   reader.readAsDataURL(file);
  // }

  onFileChange(event: Event, row: number): void {
    const form = this.formArray.at(row);
    if (!form) {
      console.error(`Form at row ${row} is undefined`);
      return;
    }

    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (!files || files.length === 0) return;

    // Reset previous file data
    const validFiles: File[] = [];
    const fileNames: string[] = [];

    for (const file of Array.from(files)) {
      // Check file type (Allow only PDF or images)
      if (!(file.type === 'application/pdf' || file.type.startsWith('image/'))) {
        Swal.fire('Only PDF or image files are allowed.', '', 'error');
        continue;
      }

      // Check file size (should be ≤ 1 MB)
      if (file.size > 1 * 1024 * 1024) {
        Swal.fire(`${file.name} exceeds the 1 MB size limit.`, '', 'error');
        continue;
      }

      validFiles.push(file);
      fileNames.push(file.name);

      // Optional: Read file as Data URL (for preview or validation)
      const reader = new FileReader();
      reader.onload = () => console.log(`${file.name} read successfully`);
      reader.onerror = (error) => console.error(`Error reading ${file.name}:`, error);
      reader.readAsDataURL(file);
    }

    // Store valid files in form
    const documentControl = form.get('document');
    const documentControlFileName = form.get('newFileName');

    if (!documentControl) {
      console.error(`'document' control is missing in form at row ${row}`);
      return;
    }
    console.log(validFiles)
    documentControl.setValue(validFiles); // Store array of files
    documentControlFileName?.setValue(fileNames.join(', ')); // Comma-separated file names

    // Clear file input value to allow re-uploading same files
    this.resetFileInput(input);
  }



  resetFileInput(input: HTMLInputElement) {
    const newInput = document.createElement("input");
    newInput.type = "file";
    newInput.accept = input.accept;
    newInput.className = input.className;
    newInput.style.display = input.style.display;
    newInput.hidden = input.hidden;
    input.parentNode?.replaceChild(newInput, input);
  }


  downloadDocument(url:any,name:any){
    if (url !=null) {
      // Find extension then set the filename extension dynamically
      const fileName = url;
      this.http.get(this.downloadUrl+fileName, { responseType: 'blob' }).subscribe((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
        URL.revokeObjectURL(link.href);
      });
    }
  }

  removeFile(row:number) {
    this.fileName = '';
    this.fileUrl = '';
    const form = this.formArray.at(row);

    //If (form.value.documentURL) is not empty then set document data again and if empty then reset
    form.get('document')?.reset();
    form.get('newFileName')?.reset();
    // form.get('document')?.setValue(form.value.oldDocument);


  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  handleDrop(event: DragEvent,row:number) {
    event.preventDefault();
    const file = event.dataTransfer?.files?.[0];
    if (file) {
      this.onFileChange({ target: { files: [file] } } as unknown as Event,row);
    }
  }

  // setDocumentByApi(fileName:any) :Observable<File>{
  //   let url = "KYCDOCUMENTS/"+fileName;
  //   this.productService.getProfileImage(url).subscribe((response:any)=>{
  //     console.log(response);
  //     if(response.type == 'application/json'){
  //       console.log("Cannot set document")
  //       throw new Error("Invalid parameters provided");
  //     }else{
  //       return new File([response], url, { type: response.type });
  //     }
  //   })
  // }

  // async setDocumentByApi(fileName: any): Promise<File> {
  //   if(fileName == undefined){
  //     throw new Error("Error fetching the document: ");
  //   }

  //   let url = "KYCDOCUMENTS/" + fileName;
  //   try {
  //     const response: any = await this.productService.getProfileImage(url).toPromise();
  //     if (response.type === 'application/json') {
  //       throw new Error("Invalid parameters provided");
  //     } else {
  //       return new File([response], url, { type: response.type });
  //     }
  //   } catch (error) {
  //     throw new Error("Error fetching the document: ");
  //   }
  // }

  async setDocumentsByApi(documentList: any[]): Promise<File[]> {
    const files: File[] = [];
    console.log(documentList)

    if(documentList.length != 0 && documentList != null){
      for (const fileName of documentList) {
        if (!fileName) continue;

        try {
          const response: any = await this.productService.getProfileImage(fileName.url).toPromise();

          if (response.type === 'application/json') {
            console.error(`Invalid file: ${fileName}`);
            continue;
          }

          const file = new File([response], fileName.name, { type: response.type });
          files.push(file);

        } catch (error) {
          console.error(`Error fetching ${fileName}:`, error);
        }
      }

      return files;
    }
    throw new Error("Error fetching the document: ")
  }


  setMaxDate() {
    const today = new Date();
    const hundredYearsLater = new Date(today.setFullYear(today.getFullYear() + 100));

    this.maxDateFromHundred = {
      year: hundredYearsLater.getFullYear(),
      month: hundredYearsLater.getMonth() + 1, // Month is 0-based
      day: hundredYearsLater.getDate()
    };
  }

  changeIdRegex(type:any,row :any){
    console.log(type)
    console.log(row)
    const form = this.formArray.at(row);
    const idControl = form.get('idNumber');

    if (type === 'Emirates ID') {
      idControl?.setValidators([
        Validators.required,
        Validators.pattern(this.eidRegex)
      ]);
    } else if (type === 'Passport') {
      idControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9]{6,9}$/)
      ]);
    }
    idControl?.updateValueAndValidity();
  }

  changeNationality(type:any,row:any){
    if(type != undefined){
      const form = this.formArray.at(row);
      form.get('nationality')?.setValue(type.name);
      form.get('nationalityCode')?.setValue(type.code);
    }
  }

  changeResidenceCountry(type:any,row :any){
    const form = this.formArray.at(row);
    const eidControl = form.get('eid');
    const eidIssueDateControl = form.get('eidIssueDate');
    const eidExpiryDateControl = form.get('eidExpiryDate');
    if(type != undefined){
      if (type.name === defaultCountryName) {
        eidControl?.setValidators([
          Validators.required,
          Validators.pattern(this.eidRegex)
        ]);
        eidIssueDateControl?.setValidators([
          Validators.required,
        ]);
        eidExpiryDateControl?.setValidators([
          Validators.required,
        ]);

        eidControl?.updateValueAndValidity();
        eidIssueDateControl?.updateValueAndValidity();
        eidExpiryDateControl?.updateValueAndValidity();
        form.get('eid')?.enable();
        form.get('eidIssueDate')?.enable();
        form.get('eidExpiryDate')?.enable();
        return;
      }
    }
    eidControl?.setValidators([
        Validators.pattern(this.eidRegex)
    ]);
    eidIssueDateControl?.setValidators([
    ]);
    eidExpiryDateControl?.setValidators([
    ]);
    eidControl?.updateValueAndValidity();
    eidIssueDateControl?.updateValueAndValidity();
    eidExpiryDateControl?.updateValueAndValidity();
    form.get('eid')?.disable();
    form.get('eidIssueDate')?.disable();
    form.get('eidExpiryDate')?.disable();
    form.get('eid')?.setValue('');
    form.get('eidIssueDate')?.setValue('');
    form.get('eidExpiryDate')?.setValue('');
  }

  getPatternErrorMessage(row:any): string {
    const form = this.formArray.at(row);
    const idType = form.get('idType')?.value;
    if (idType === 'Emirates ID') {
      return 'Enter a valid Emirates ID in the format 784-XXXX-XXXXXXX-X';
    } else if (idType === 'Passport') {
      return 'Enter a valid Passport Number (6–9 alphanumeric characters)';
    }
    return 'Invalid format';
  }

  async deletedDocument(id:any,documentName : any){
    console.log(id)
    console.log(documentName)
      await Swal.fire({
        title: "Are you sure ?",
        text: "You want to delete this document",
        confirmButtonText: '<span id="confirm-button-text">Yes</span>',
        showCancelButton: true,
        reverseButtons: false,
        confirmButtonColor: '#e61c1c',
        cancelButtonColor: '#7987a1',
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom'
        },
      }).then((result) => {
        if (result.isConfirmed) {
            if(id != '' && documentName != ''){
              this.merchantService.deleteUBODocument(id,documentName).subscribe((response:any)=>{
              console.log(response);
              if(response.response.httpStatus == "OK"){
                Swal.fire(response.response.data+" "+response.response.message,'','success');
                this.fetchUBODetails();
                return;
              }else{
                Swal.fire(response.response.message,'','error');
                this.fetchUBODetails();
                return;
              }
              })
            }
          }
        });
  }

  getDocumentErrorMessage(row:any): void {
    const form = this.formArray.at(row);
    const documentList = form.get('document')?.value;
    const formDoc = form.get('document');
    console.log(documentList)
    const formId = form.get('id')?.value;
    console.log(formId)
    if ((formId == ''|| formId == null) && (documentList?.length == 0 || documentList == '' || documentList == null) ) {
      console.log("Enable Required Document")
      formDoc?.setValidators([Validators.required]);
    }else{
      formDoc?.clearValidators();
    }
    formDoc?.updateValueAndValidity();
  }

  icpLink(linkNumber : any){
    if(linkNumber == 1){
      window.open('https://smartservices.icp.gov.ae/echannels/web/client/default.html#/fileValidity', '_blank');
    }else if(linkNumber == 2){
      window.open('https://smart.gdrfad.gov.ae/Public_Th/StatusInquiry_New.aspx', '_blank');
    }
  }

  private formatEmiratesIdForDisplay(eid: string): string {
    if (!eid) return '';

    const cleanValue = eid.toString().replace(/[^0-9]/g, '');

    if (cleanValue.length === 15) {
      return `${cleanValue.slice(0, 3)}-${cleanValue.slice(3, 7)}-${cleanValue.slice(7, 14)}-${cleanValue.slice(14)}`;
    }

    return eid;
  }

}


